/**
 * @fileoverview Agent definition for prose-continuer-discovery-neutral.
 *
 * A reduced variant of prose-continuer-discovery focused on character momentum
 * and emerging narrative. Outputs deliberately neutral prose intended to be
 * transformed by a downstream stylization pass (e.g., style-aligner-v2).
 *
 * @category narrative.prose.drafting
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'prose-continuer-discovery-neutral',
  kind: 'primitive',
  name: 'Continue (Discovery, Neutral)',
  description: 'Continues the story through exploratory, character-driven writing in deliberately neutral prose. Intended to be paired with a downstream stylization pass.',
  category: 'writing',
  defaultPrompt: prompt,
  systemPrompt: `You are a narrative architect continuing fiction prose in discovery mode. You follow character momentum and let the next beat emerge organically, but you prioritize continuity, pacing, and clarity over style. You write in plain, workmanlike prose; a downstream stylization pass will apply voice and tone.`,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata (Hybrid Architecture) ---
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-05',
    lastUpdated: '2026-05',
    taxonomyPath: 'narrative.prose.drafting',
    usedBy: [],
    usedInComposites: [],
    relatedAgents: [
      'prose-continuer-discovery',
      'prose-continuer-guided-neutral',
      'chapter-drafter-v2-neutral',
      'style-aligner-v2',
    ],
  },
};
